// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider {
  padding: 0;
  border: 0;
}
ion-item-divider#search-divider #filter-btn {
  --padding-end: 24px;
}
ion-item-divider #position-btn {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
  justify-content: flex-end;
}

.code-input {
  border-radius: 100px;
  background: var(--input-box-filled-active, #FFF);
  height: 63px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.code-input img {
  width: 27%;
}

#stepOne .confirm {
  color: var(--subttulos, #0C2340);
  text-align: center;
  font-family: Montserrat;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
}
#stepOne .message {
  color: var(--body, #43556A);
  text-align: center;
  font-family: "Montserrat";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
#stepOne .code {
  color: var(--error, #F20F0F);
  text-align: center;
  font-family: "Montserrat";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
#stepOne .code-input {
  height: 63px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background: #FFF;
}
#stepOne .no-code {
  color: var(--body, #43556A);
  font-family: "Montserrat";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
#stepOne .no-code span {
  color: #EBA783;
  font-family: "Montserrat";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  cursor: pointer;
}

.img-product {
  width: 70px;
  border-radius: 10px !important;
  overflow: hidden;
}

#subtitle-2 {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
}
#subtitle-2 #product-stock-title,
#subtitle-2 #product-edit,
#subtitle-2 #product-stock-add {
  width: 50%;
  color: var(--ion-text-color);
}
#subtitle-2 #product-stock-title {
  margin-left: 24px;
  font-size: 17px;
  font-weight: 500;
}
#subtitle-2 .store-item {
  font-size: 14px;
}
#subtitle-2 .store-item.item-title {
  font-weight: 700;
  color: var(--ion-color-dark);
}
#subtitle-2 .store-item.item-price {
  font-weight: 700;
  color: var(--ion-color-primary);
}
#subtitle-2 #product-stock-add {
  font-size: 14px;
  font-weight: 500;
  text-align: right;
}
#subtitle-2 #product-stock-add ion-button {
  --padding-end: 24px;
  text-transform: capitalize;
}
#subtitle-2 #product-stock-add ion-button ion-icon {
  margin-right: 3px;
  width: 32px !important;
  height: 32px !important;
}

.prod-title {
  font-weight: 600;
}

.item-prod {
  --background: #ffffff;
}

.cont-item {
  padding: 10px 0px;
}
.cont-item span {
  border: 1px solid gray;
  padding: 3px 6px;
  border-radius: 5px;
  margin-right: 10px;
}

.status-task {
  float: right;
}

.status-pending {
  width: 13px;
  height: 13px;
  color: var(--ion-color-danger) !important;
  border-radius: 50%;
  margin-left: 7px;
}

.status-success {
  width: 13px;
  height: 13px;
  color: var(--ion-color-success) !important;
  border-radius: 50%;
  margin-left: 7px;
}

#tasks-right-pane {
  display: none;
}

#tasks-left-pane {
  width: 100%;
}

@media (min-width: 960px) {
  #tasks-right-pane {
    display: block;
  }
  .split-pane-container {
    height: 100vh;
  }
}
.main-title div {
  padding-left: 51px;
  margin-bottom: 0px;
  position: relative;
}
.main-title div .add-icon {
  height: 40px;
  position: absolute;
  right: 0px;
  width: 40px;
  cursor: pointer;
}
.main-title div .back-icon {
  height: 18px;
  border-radius: 50%;
  padding: 8px;
  width: 18px;
  cursor: pointer;
  color: #ffffff;
  position: absolute;
  left: 0px;
  background: var(--ion-color-primary);
}

.pwa-left-pane {
  margin-bottom: 20px;
  padding: 0px 40px 0px 80px;
}

.pwa-right-pane {
  padding: 0px 80px 0px 40px;
}

ion-item-divider {
  border-bottom: none;
}

#mainModules {
  margin-top: 24px;
  background: transparent;
  padding-left: 3px;
  padding-right: 3px;
}
#mainModules ion-item {
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  margin-bottom: 16px;
  color: #505B69;
  cursor: pointer;
}
#mainModules ion-item .arrow-icon {
  width: 32px;
  height: 32px;
}
#mainModules ion-item .icon-item {
  width: 40px;
  height: 40px;
  color: var(--ion-item-primary);
}
#mainModules ion-item ion-label {
  padding-left: 10px;
}
#mainModules ion-item ion-label h2 {
  color: var(--ion-color-primary);
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
}
#mainModules ion-item ion-label p {
  color: #A1A1A1;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

#AccountOptions {
  margin-top: 24px;
  background: transparent;
  padding-left: 3px;
  padding-right: 3px;
}
#AccountOptions ion-item {
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  margin-bottom: 16px;
  color: #505B69;
  cursor: pointer;
}
#AccountOptions ion-item .arrow-icon {
  width: 32px;
  height: 32px;
}
#AccountOptions ion-item .icon-item {
  width: 32px;
  height: 32px;
  color: var(--ion-item-primary);
}
#AccountOptions ion-item ion-label {
  padding-left: 10px;
}
#AccountOptions ion-item ion-label h2 {
  font-family: Montserrat;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
}

.action-icon {
  cursor: pointer;
}

.item-checked ion-label {
  color: var(--ion-color-secondary) !important;
}
.item-checked h2 {
  color: var(--ion-color-secondary) !important;
}

ion-item {
  --highlight-color-focused: none;
}

.item-pass {
  border-radius: 8px;
  border: 1px solid var(--success, #05B300);
  background: #FFF;
  margin-bottom: 20px;
}
.item-pass ion-input {
  --highlight-color-focused: none;
}
.item-pass ion-icon {
  position: absolute;
  right: 0px;
  z-index: 9;
  cursor: pointer;
}
.item-pass ion-label {
  color: var(--success, #05B300) !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.005px;
}
.item-pass .item-has-focus ion-label {
  color: var(--success, #05B300) !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.005px;
}
.item-pass ion-input {
  font-size: 16px;
  --ion-font-size: 15px;
  padding-right: 32px !important;
}

.detail-title {
  display: flex;
  align-items: center;
  margin-top: 97px;
  margin-bottom: 24px;
  line-height: 1;
  font-size: 34px;
  font-weight: 700;
  position: relative;
}
.detail-title .step-items {
  border-radius: 8px;
  background: var(--ion-color-primary);
  color: #FFF;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  width: 36px;
  height: 32px;
  position: absolute;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail-title ion-icon {
  height: 22px;
  border-radius: 50%;
  padding: 8px;
  position: absolute;
  right: 0px;
  width: 22px;
  cursor: pointer;
  color: #ffffff;
  background: var(--ion-color-primary);
}
.detail-title .subtitle {
  padding-left: 51px;
  margin-bottom: 0px;
  position: relative;
}
.detail-title .back-icon {
  left: 0px;
}

.subtitle-mt {
  margin-top: 40px;
}

.account-item-selected {
  --background: rgba(22, 54, 96, 0.10);
}

.sign-out {
  color: var(--error, #F20F0F);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  cursor: pointer;
}

#passwordSection .title {
  color: var(--ion-color-primary);
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 8px;
}
#passwordSection .subtitle {
  color: var(--text-info, #A1A1A1);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}
#passwordSection .item-password {
  border-radius: 8px;
  border: 1px solid var(--success, #05B300);
  background: #FFF;
  height: 66px;
  margin-bottom: 16px;
}

.section-logo {
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  padding-top: 16px;
  padding-bottom: 16px;
  text-align: center;
  min-height: 273px;
  margin-left: 3px;
  margin-right: 3px;
}
.section-logo .container-image {
  padding: 5px;
  width: 149px;
  height: 149px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
  border: 4px solid var(--icons, #0C2340);
  position: relative;
}
.section-logo .container-image div {
  width: 131px;
  height: 131px;
  border-radius: 50%;
  padding: 5px;
  background-size: cover;
}
.section-logo .default-image {
  padding: 5px;
  width: 149px;
  height: 149px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
  border: 4px solid var(--icons, #0C2340);
}
.section-logo .default-image img {
  width: 142px;
  height: 132px;
  border-radius: 50%;
  border: none;
}
.section-logo .business-name {
  color: var(--ion-color-primary);
  text-align: center;
  font-size: 22px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 16px;
}
.section-logo .company-name {
  color: #586677;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  margin-top: 0px;
}

#deleteAccountSection .delete-title {
  color: var(--ion-color-primary);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
#deleteAccountSection .delete-detail {
  color: var(--text-body, #736D76);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

@media (max-width: 600px) {
  #mainModules {
    margin-top: 24px;
    background: transparent;
    padding-left: 3px;
    padding-right: 3px;
  }
  #mainModules ion-item {
    border-radius: 8px;
    background: #FFF;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
    margin-bottom: 16px;
    color: #505B69;
    cursor: pointer;
    --padding-start: 16px;
    --padding-end: 16px;
  }
  #mainModules ion-item .arrow-icon {
    width: 32px;
    height: 32px;
    margin-left: 8px;
  }
  #mainModules ion-item .icon-item {
    width: 32px;
    height: 32px;
    margin-right: 5px;
  }
  #mainModules ion-item ion-label {
    padding-left: 10px;
  }
  #mainModules ion-item ion-label h2 {
    color: #2D4462;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
  }
  #mainModules ion-item ion-label p {
    color: #A1A1A1;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
  }
}
.icon-GETNET {
  color: #e51514 !important;
}

.icon-VENTASCLICK {
  color: #3c4efa !important;
}

.icon-BOXX {
  color: #4287f0;
}

.item-menu {
  border-radius: 16px;
  background: #FFF;
  border: 2px solid #ececec;
  margin-bottom: 24px;
}
.item-menu .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item-menu .container .section {
  display: flex;
  align-items: center;
}
.item-menu .container .section .icon-section {
  color: #4287f0;
  padding-top: 16px;
  padding-left: 16px;
}
.item-menu .container h2 {
  color: var(--text-Ttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0px;
  padding-top: 16px;
  padding-left: 8px;
}
.item-menu .container .arrow {
  width: 24px;
  height: 24px;
  color: var(--ion-color-primary);
  margin: 0px;
  padding-top: 16px;
  padding-right: 16px;
}
.item-menu .detail p {
  margin-top: 0px;
  padding: 4px 16px 0px 47px;
  color: var(--text-Info, #788089);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 90%;
}

.sign-out {
  color: var(--UI-Error, #D50000);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: flex;
  align-items: center;
  padding-left: 8px;
  margin-top: 0px;
}
.sign-out ion-icon {
  padding-right: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/support/components/support/support.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;AACF;AAEI;EACE,mBAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;AAFJ;;AAOA;EACE,oBAAA;EACA,gDAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;AAME;EACE,UAAA;AAJJ;;AASE;EACE,gCAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;AASE;EACE,2BAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAPJ;AAUE;EACE,4BAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AARJ;AAWE;EACE,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AATJ;AAYE;EACE,2BAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAVJ;AAYI;EACE,cAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAVN;;AAoBA;EACE,WAAA;EACA,8BAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AAjBF;AAmBE;;;EAGE,UAAA;EACA,4BAAA;AAjBJ;AAoBE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AAlBJ;AAqBE;EACE,eAAA;AAnBJ;AAqBI;EACE,gBAAA;EACA,4BAAA;AAnBN;AAsBI;EACE,gBAAA;EACA,+BAAA;AApBN;AAwBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAtBJ;AAwBI;EACE,mBAAA;EACA,0BAAA;AAtBN;AAwBM;EACE,iBAAA;EACA,sBAAA;EACA,uBAAA;AAtBR;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,qBAAA;AAzBF;;AA4BA;EACE,iBAAA;AAzBF;AA2BE;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAzBJ;;AA6BA;EACE,YAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AA1BF;;AAgCA;EACE,aAAA;AA7BF;;AAgCA;EACE,WAAA;AA7BF;;AAiCA;EASE;IACE,cAAA;EAtCF;EA8CA;IACE,aAAA;EA5CF;AACF;AAkDA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AAhDF;AAkDE;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;AAhDJ;AAmDE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,oCAAA;AAjDJ;;AAsDA;EACE,mBAAA;EAGA,0BAAA;AArDF;;AAwDA;EACE,0BAAA;AArDF;;AAwDA;EACE,mBAAA;AArDF;;AAyDA;EACE,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAtDF;AAwDE;EACE,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAtDJ;AAwDI;EACE,WAAA;EACA,YAAA;AAtDN;AAyDI;EACE,WAAA;EACA,YAAA;EACA,8BAAA;AAvDN;AA0DI;EACE,kBAAA;AAxDN;AA0DM;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAxDR;AA2DM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzDR;;AA+DA;EACE,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AA5DF;AA8DE;EACE,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA5DJ;AA8DI;EACE,WAAA;EACA,YAAA;AA5DN;AA+DI;EACE,WAAA;EACA,YAAA;EACA,8BAAA;AA7DN;AAgEI;EACE,kBAAA;AA9DN;AAgEM;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA9DR;;AAoEA;EACE,eAAA;AAjEF;;AAqEE;EACE,4CAAA;AAlEJ;AAqEE;EACE,4CAAA;AAnEJ;;AAuEA;EACE,+BAAA;AApEF;;AAuEA;EACE,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,mBAAA;AApEF;AAsEE;EACE,+BAAA;AApEJ;AAuEE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AArEJ;AAwEE;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AAtEJ;AA0EI;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AAxEN;AA8EE;EACE,eAAA;EACA,qBAAA;EACA,8BAAA;AA5EJ;;AAiFA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA9EF;AAgFE;EACE,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA9EJ;AAiFE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;AA/EJ;AAkFE;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AAhFJ;AAmFE;EACE,SAAA;AAjFJ;;AAqFA;EACE,gBAAA;AAlFF;;AAqFA;EACE,oCAAA;AAlFF;;AAqFA;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAlFF;;AAsFE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAnFJ;AAsFE;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AApFJ;AAuFE;EACE,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AArFJ;;AA0FA;EACE,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAvFF;AAyFE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,uCAAA;EACA,kBAAA;AAvFJ;AAyFI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;AAvFN;AA2FE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,uCAAA;AAzFJ;AA2FI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAzFN;AA6FE;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA3FJ;AA8FE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA5FJ;;AAkGE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA/FJ;AAkGE;EACE,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAhGJ;;AAoGA;EACE;IACE,gBAAA;IACA,uBAAA;IACA,iBAAA;IACA,kBAAA;EAjGF;EAmGE;IACE,kBAAA;IACA,gBAAA;IACA,+CAAA;IACA,mBAAA;IACA,cAAA;IACA,eAAA;IACA,qBAAA;IACA,mBAAA;EAjGJ;EAmGI;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAjGN;EAoGI;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAlGN;EAsGI;IACE,kBAAA;EApGN;EAsGM;IACE,cAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EApGR;EAuGM;IACE,cAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EArGR;AACF;AA2GA;EACE,yBAAA;AAzGF;;AA4GA;EACE,yBAAA;AAzGF;;AA4GA;EACE,cAAA;AAzGF;;AA6GA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AA1GF;AA4GE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA1GJ;AA4GI;EACE,aAAA;EACA,mBAAA;AA1GN;AA4GM;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AA1GR;AA8GI;EACE,kCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;AA5GN;AA+GI;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AA7GN;AAkHI;EACE,eAAA;EACA,0BAAA;EACA,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;AAhHN;;AAsHA;EACE,+BAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAnHF;AAqHE;EACE,kBAAA;AAnHJ","sourcesContent":["ion-item-divider {\n  padding: 0;\n  border: 0;\n\n  &#search-divider {\n    #filter-btn {\n      --padding-end: 24px;\n    }\n  }\n\n  #position-btn {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    justify-content: flex-end;\n\n  }\n}\n\n.code-input {\n  border-radius: 100px;\n  background: var(--input-box-filled-active, #FFF);\n  height: 63px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  img {\n    width: 27%;\n  }\n}\n\n#stepOne {\n  .confirm {\n    color: var(--subttulos, #0C2340);\n    text-align: center;\n    font-family: Montserrat;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px;\n  }\n\n  .message {\n    color: var(--body, #43556A);\n    text-align: center;\n    font-family: \"Montserrat\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 21px;\n  }\n\n  .code {\n    color: var(--error, #F20F0F);\n    text-align: center;\n    font-family: \"Montserrat\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n  }\n\n  .code-input {\n    height: 63px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    background: #FFF;\n  }\n\n  .no-code {\n    color: var(--body, #43556A);\n    font-family: \"Montserrat\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 21px;\n\n    span {\n      color: #EBA783;\n      font-family: \"Montserrat\";\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 21px;\n      cursor: pointer;\n    }\n  }\n\n}\n\nion-item-divider {\n  //background: #ffffff;\n}\n\n.img-product {\n  width: 70px;\n  border-radius: 10px !important;\n  overflow: hidden;\n}\n\n#subtitle-2 {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  #product-stock-title,\n  #product-edit,\n  #product-stock-add {\n    width: 50%;\n    color: var(--ion-text-color);\n  }\n\n  #product-stock-title {\n    margin-left: 24px;\n    font-size: 17px;\n    font-weight: 500;\n  }\n\n  .store-item {\n    font-size: 14px;\n\n    &.item-title {\n      font-weight: 700;\n      color: var(--ion-color-dark);\n    }\n\n    &.item-price {\n      font-weight: 700;\n      color: var(--ion-color-primary);\n    }\n  }\n\n  #product-stock-add {\n    font-size: 14px;\n    font-weight: 500;\n    text-align: right;\n\n    ion-button {\n      --padding-end: 24px;\n      text-transform: capitalize;\n\n      ion-icon {\n        margin-right: 3px;\n        width: 32px !important;\n        height: 32px !important;\n      }\n    }\n  }\n}\n\n.prod-title {\n  font-weight: 600;\n}\n\n.item-prod {\n  --background: #ffffff;\n}\n\n.cont-item {\n  padding: 10px 0px;\n\n  span {\n    border: 1px solid gray;\n    padding: 3px 6px;\n    border-radius: 5px;\n    margin-right: 10px;\n  }\n}\n\n.status-task {\n  float: right;\n}\n\n.status-pending {\n  width: 13px;\n  height: 13px;\n  color: var(--ion-color-danger) !important;\n  border-radius: 50%;\n  margin-left: 7px;\n}\n\n.status-success {\n  width: 13px;\n  height: 13px;\n  color: var(--ion-color-success) !important;\n  border-radius: 50%;\n  margin-left: 7px;\n}\n\n\n\n\n#tasks-right-pane {\n  display: none;\n}\n\n#tasks-left-pane {\n  width: 100%;\n}\n\n//PWA\n@media (min-width: 960px) {\n  ion-item {\n    //cursor: pointer;\n  }\n\n  // #tasks-left-pane {\n  //   width: 42%;\n  // }\n\n  #tasks-right-pane {\n    display: block;\n  }\n\n\n  ion-header {\n    //display: none;\n  }\n\n  .split-pane-container {\n    height: 100vh;\n  }\n\n}\n\n\n\n.main-title div {\n  padding-left: 51px;\n  margin-bottom: 0px;\n  position: relative;\n\n  .add-icon {\n    height: 40px;\n    position: absolute;\n    right: 0px;\n    width: 40px;\n    cursor: pointer;\n  }\n\n  .back-icon {\n    height: 18px;\n    border-radius: 50%;\n    padding: 8px;\n    width: 18px;\n    cursor: pointer;\n    color: #ffffff;\n    position: absolute;\n    left: 0px;\n    background: var(--ion-color-primary);\n  }\n}\n\n\n.pwa-left-pane {\n  margin-bottom: 20px;\n  // padding: 0px 80px;\n  // padding-bottom: 10px;\n  padding: 0px 40px 0px 80px;\n}\n\n.pwa-right-pane {\n  padding: 0px 80px 0px 40px;\n}\n\nion-item-divider {\n  border-bottom: none;\n}\n\n\n#mainModules {\n  margin-top: 24px;\n  background: transparent;\n  padding-left: 3px;\n  padding-right: 3px;\n\n  ion-item {\n    border-radius: 8px;\n    background: #FFF;\n    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n    margin-bottom: 16px;\n    color: #505B69;\n    cursor: pointer;\n\n    .arrow-icon {\n      width: 32px;\n      height: 32px;\n    }\n\n    .icon-item {\n      width: 40px;\n      height: 40px;\n      color: var(--ion-item-primary);\n    }\n\n    ion-label {\n      padding-left: 10px;\n\n      h2 {\n        color: var(--ion-color-primary);\n        font-size: 22px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 28px;\n      }\n\n      p {\n        color: #A1A1A1;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 21px;\n      }\n    }\n  }\n}\n\n#AccountOptions {\n  margin-top: 24px;\n  background: transparent;\n  padding-left: 3px;\n  padding-right: 3px;\n\n  ion-item {\n    border-radius: 8px;\n    background: #FFF;\n    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n    margin-bottom: 16px;\n    color: #505B69;\n    cursor: pointer;\n\n    .arrow-icon {\n      width: 32px;\n      height: 32px;\n    }\n\n    .icon-item {\n      width: 32px;\n      height: 32px;\n      color: var(--ion-item-primary);\n    }\n\n    ion-label {\n      padding-left: 10px;\n\n      h2 {\n        font-family: Montserrat;\n        font-size: 17px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 22px;\n      }\n    }\n  }\n}\n\n.action-icon {\n  cursor: pointer;\n}\n\n.item-checked {\n  ion-label {\n    color: var(--ion-color-secondary) !important;\n  }\n\n  h2 {\n    color: var(--ion-color-secondary) !important;\n  }\n}\n\nion-item {\n  --highlight-color-focused: none;\n}\n\n.item-pass {\n  border-radius: 8px;\n  border: 1px solid var(--success, #05B300);\n  background: #FFF;\n  margin-bottom: 20px;\n\n  ion-input {\n    --highlight-color-focused: none;\n  }\n\n  ion-icon {\n    position: absolute;\n    right: 0px;\n    z-index: 9;\n    cursor: pointer;\n  }\n\n  ion-label {\n    color: var(--success, #05B300) !important;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: -0.005px;\n  }\n\n  .item-has-focus {\n    ion-label {\n      color: var(--success, #05B300) !important;\n      font-size: 15px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      letter-spacing: -0.005px;\n    }\n\n  }\n\n\n  ion-input {\n    font-size: 16px;\n    --ion-font-size: 15px;\n    padding-right: 32px !important;\n  }\n}\n\n\n.detail-title {\n  display: flex;\n  align-items: center;\n  margin-top: 97px;\n  margin-bottom: 24px;\n  line-height: 1;\n  font-size: 34px;\n  font-weight: 700;\n  position: relative;\n\n  .step-items {\n    border-radius: 8px;\n    background: var(--ion-color-primary);\n    color: #FFF;\n    text-align: center;\n    font-family: Montserrat;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n    width: 36px;\n    height: 32px;\n    position: absolute;\n    right: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  ion-icon {\n    height: 22px;\n    border-radius: 50%;\n    padding: 8px;\n    position: absolute;\n    right: 0px;\n    width: 22px;\n    cursor: pointer;\n    color: #ffffff;\n    background: var(--ion-color-primary);\n  }\n\n  .subtitle {\n    padding-left: 51px;\n    margin-bottom: 0px;\n    position: relative;\n  }\n\n  .back-icon {\n    left: 0px;\n  }\n}\n\n.subtitle-mt {\n  margin-top: 40px;\n}\n\n.account-item-selected {\n  --background: rgba(22, 54, 96, 0.10);\n}\n\n.sign-out {\n  color: var(--error, #F20F0F);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 21px;\n  cursor: pointer;\n}\n\n#passwordSection {\n  .title {\n    color: var(--ion-color-primary);\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px;\n    margin-bottom: 8px;\n  }\n\n  .subtitle {\n    color: var(--text-info, #A1A1A1);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n  }\n\n  .item-password {\n    border-radius: 8px;\n    border: 1px solid var(--success, #05B300);\n    background: #FFF;\n    height: 66px;\n    margin-bottom: 16px;\n  }\n}\n\n\n.section-logo {\n  border-radius: 8px;\n  background: #FFF;\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n  padding-top: 16px;\n  padding-bottom: 16px;\n  text-align: center;\n  min-height: 273px;\n  margin-left: 3px;\n  margin-right: 3px;\n\n  .container-image {\n    padding: 5px;\n    width: 149px;\n    height: 149px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    border: 4px solid var(--icons, #0C2340);\n    position: relative;\n\n    div {\n      width: 131px;\n      height: 131px;\n      border-radius: 50%;\n      padding: 5px;\n      background-size: cover;\n    }\n  }\n\n  .default-image {\n    padding: 5px;\n    width: 149px;\n    height: 149px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    border: 4px solid var(--icons, #0C2340);\n\n    img {\n      width: 142px;\n      height: 132px;\n      border-radius: 50%;\n      border: none;\n    }\n  }\n\n  .business-name {\n    color: var(--ion-color-primary);\n    text-align: center;\n    font-size: 22px;\n    font-family: Montserrat;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px;\n    margin-bottom: 16px;\n  }\n\n  .company-name {\n    color: #586677;\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 21px;\n    margin-top: 0px;\n  }\n}\n\n\n#deleteAccountSection {\n  .delete-title {\n    color: var(--ion-color-primary);\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n  }\n\n  .delete-detail {\n    color: var(--text-body, #736D76);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 21px;\n  }\n}\n\n@media (max-width: 600px) {\n  #mainModules {\n    margin-top: 24px;\n    background: transparent;\n    padding-left: 3px;\n    padding-right: 3px;\n\n    ion-item {\n      border-radius: 8px;\n      background: #FFF;\n      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n      margin-bottom: 16px;\n      color: #505B69;\n      cursor: pointer;\n      --padding-start: 16px;\n      --padding-end: 16px;\n\n      .arrow-icon {\n        width: 32px;\n        height: 32px;\n        margin-left: 8px;\n      }\n\n      .icon-item {\n        width: 32px;\n        height: 32px;\n        margin-right: 5px;\n        //color: #3C7CCF !important;\n      }\n\n      ion-label {\n        padding-left: 10px;\n\n        h2 {\n          color: #2D4462;\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: 28px;\n        }\n\n        p {\n          color: #A1A1A1;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 21px;\n        }\n      }\n    }\n  }\n}\n\n.icon-GETNET {\n  color: #e51514 !important;\n}\n\n.icon-VENTASCLICK {\n  color: #3c4efa !important;\n}\n\n.icon-BOXX {\n  color: #4287f0;\n}\n\n//New\n.item-menu {\n  border-radius: 16px;\n  background: #FFF;\n  border: 2px solid #ececec;\n  margin-bottom: 24px;\n\n  .container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .section {\n      display: flex;\n      align-items: center;\n\n      .icon-section {\n        color: #4287f0;\n        padding-top: 16px;\n        padding-left: 16px;\n      }\n    }\n\n    h2 {\n      color: var(--text-Ttulos, #0D253A);\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      margin: 0px;\n      padding-top: 16px;\n      padding-left: 8px;\n    }\n\n    .arrow {\n      width: 24px;\n      height: 24px;\n      color: var(--ion-color-primary);\n      margin: 0px;\n      padding-top: 16px;\n      padding-right: 16px;\n    }\n  }\n\n  .detail {\n    p {\n      margin-top: 0px;\n      padding: 4px 16px 0px 47px;\n      color: var(--text-Info, #788089);\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      width: 90%;\n    }\n  }\n\n}\n\n.sign-out {\n  color: var(--UI-Error, #D50000);\n  font-feature-settings: \"liga\" off, \"clig\" off;\n  font-family: \"Poppins\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  display: flex;\n  align-items: center;\n  padding-left: 8px;\n  margin-top: 0px;\n\n  ion-icon{\n    padding-right: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
